import {
  DigitOrderItem,
  quickGameOrder,
} from '@/common-pages/pick-digit/digit-service';
import React from 'react';
import ResultPanel from '../components/result-panel/result-panel';
import {useTranslation} from 'react-i18next';
import globalStore from '@/services/global.state';
import theme from '@/style';
import Text from '@/components/basic/text';
import {StyleSheet, View} from 'react-native';
import dayjs from 'dayjs';
import {goTo, toPriceStr} from '@/utils';
// import {NativeTouchableOpacity} from '@/components/basic/touchable-opacity';
// import {downIcon} from '@/common-pages/rebate/rebate.variables';
import DigitBall from '@/common-pages/pick-digit/components/digit-ball';

const charBg = require('@/components/assets/imgs/result/3d/char-bg.webp');
const numBg = require('@/components/assets/imgs/result/3d/num-bg.webp');

const DigitDraw = ({id}: {id?: number}) => {
  const [order, setOrder] = React.useState<DigitOrderItem>();
  const {t} = useTranslation();

  const getQuickOrder = async (pickThreeId: number) => {
    try {
      const res = await quickGameOrder({
        pickThreeId,
        pageNo: 1,
        pageSize: 1,
        orderStatus: 4,
      });
      if (res?.records) {
        setOrder(res.records[0]);
      }
    } finally {
    }
  };

  React.useEffect(() => {
    if (id && globalStore.token) {
      getQuickOrder(id);
    }
  }, [id]);

  return order?.orderGroup ? (
    <ResultPanel
      winAmount={order.winAmount}
      onMore={() => goTo('Bets', {tag: 'Quick 3D'})}
      betInfo={order?.timeName}
      betTime={dayjs(order?.createTime).format('DD-MM-YYYY hh:mm A')}>
      <View style={[theme.padding.lrl, theme.padding.tops]}>
        <Text textAlign="center">{t('game-page.label.myBets')}</Text>
        <View style={[theme.margin.tops, {gap: theme.paddingSize.xxs / 2}]}>
          {order?.codeLists?.slice(0, 3).map((item, _i) => {
            const indexArr = item.indexCode.split('=')[0].split('');
            const digitArr = item.indexCode.split('=')[1].split('');
            return (
              <View
                key={_i}
                style={[
                  theme.padding.s,
                  theme.borderRadius.m,
                  theme.flex.between,
                  theme.flex.centerByCol,
                  theme.flex.row,
                  styles.digitOrderItem,
                ]}>
                <View
                  style={[
                    theme.flex.row,
                    theme.flex.centerByCol,
                    styles.digitOrderRow,
                  ]}>
                  {indexArr.map((pie, _ii) => (
                    <DigitBall
                      ballSize={24}
                      digit={pie}
                      color={pie}
                      backgroundImage={charBg}
                      key={_ii}
                    />
                  ))}
                  <Text
                    size="medium"
                    fontFamily="fontInterBold"
                    style={styles.equalText}>
                    =
                  </Text>
                  {digitArr.map((pie, _ii) => (
                    <DigitBall
                      ballSize={24}
                      digit={pie}
                      color={indexArr[_ii]}
                      backgroundImage={numBg}
                      key={_ii}
                    />
                  ))}
                  <View
                    style={[
                      theme.borderRadius.s,
                      theme.margin.leftxxs,
                      styles.pickCount,
                    ]}>
                    <Text fontSize={10} color={'#fff'}>
                      x{item.pickCount}
                    </Text>
                  </View>
                </View>
                <View style={[theme.flex.row, theme.flex.centerByCol]}>
                  <Text fontSize={12}>
                    {item.winAmount > 0 ? 'Won ' : 'No Win '}
                  </Text>
                  <Text
                    color={item.winAmount ? '#F15802' : '#000'}
                    size="medium"
                    fontFamily="fontDinBold">
                    {toPriceStr(item.winAmount)}
                  </Text>
                </View>
              </View>
            );
          })}
        </View>
        {/* {order?.codeLists && order.codeLists?.length > 3 && (
          <NativeTouchableOpacity
            style={[
              theme.flex.row,
              theme.flex.centerByCol,
              theme.flex.between,
              theme.padding.tbs,
            ]}>
            <Text>View all</Text>
            <View
              style={[
                theme.margin.leftxxs,
                {
                  transform: [
                    {
                      rotate: '-90deg',
                    },
                  ],
                },
              ]}>
              <Image source={downIcon} style={[theme.icon.xs]} />
            </View>
          </NativeTouchableOpacity>
        )} */}
      </View>
    </ResultPanel>
  ) : null;
};

const styles = StyleSheet.create({
  digitOrderItem: {
    backgroundColor: '#F6F7FA',
  },
  digitOrderRow: {
    gap: theme.paddingSize.xxs,
  },
  pickCount: {
    backgroundColor: '#F15802',
    minWidth: 20,
    height: 16,
    paddingHorizontal: 4,
    justifyContent: 'center',
    alignItems: 'center',
  },
  equalText: {
    color: '#000',
  },
});

export default DigitDraw;
